import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import { storeInit } from './store.js';

import App from './lib/App/App.svelte';
import { mount } from 'svelte';

// @ts-ignore
const data = window.ForgottenPasswordData;

storeInit(data);

const app = mount(App, {
    target: document.getElementById('forgotten-password'),
    props: data
});

export default app;
